<template>
  <div class="payment-detail-form">
    <InfoContainer
      :infoTitle="formConfig['infoTitle']"
      :contentConfig="formConfig['infoContent']"
    >
      <template #basicInfo>
        <avue-form
          ref="lendingInfo"
          v-if="!isDetail"
          v-model="lendingForm"
          :option="lendingFormConfig"
        >
          <template #investBatchStr>
            <div class="slot-content">第{{ investBatch }}批</div>
          </template>

          <template #bankInfo>
            <div class="slot-content">
              {{
                lendingForm.custBankBl
                  ? lendingForm.custBankBl.bankAccountName
                  : ""
              }}
              {{
                lendingForm.custBankBl
                  ? lendingForm.custBankBl.bankOpenName
                  : ""
              }}
              {{ lendingForm.custBankBl ? lendingForm.custBankBl.bankNo : "" }}
            </div>
          </template>

          <template #investAllMoney>
            <div class="slot-content green-word">
              {{
                lendingForm.investAllMoney
                  ? `${getMoney(Number(lendingForm.investAllMoney))}元`
                  : "无"
              }}
            </div>
          </template>

          <template #investAlreadyMoney>
            <div class="slot-content green-word">
              {{
                lendingForm.investAlreadyMoney
                  ? `${getMoney(Number(lendingForm.investAlreadyMoney))}元`
                  : "无"
              }}
            </div>
          </template>

          <template #lastMoney>
            <div class="slot-content green-word">
              {{
                `${getMoney(
                  Number(lendingForm.investAllMoney) -
                    Number(lendingForm.investAlreadyMoney)
                )}元`
              }}
            </div>
          </template>

          <template #rentDate>
            <div class="slot-content green-word">
              {{ lendingForm.rentDate }}
            </div>
          </template>

          <template #presentCostSum>
            <div class="slot-content green-word">
              {{ getMoney(lendingForm.presentCostSum) }}元
            </div>
          </template>

          <template #actuallPayment>
            <div class="slot-content green-word">
              {{ getMoney(lendingForm.actuallPayment) }}元
            </div>
          </template>

          <template #innerMoney>
            <el-table :data="lendingForm.innerList" border style="width: 100%">
              <el-table-column
                type="index"
                align="center"
                label="序号"
                width="50"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="moneyType"
                label="款项类型"
              >
                <template slot-scope="scope">
                  <div
                    class="money-type"
                    v-if="scope.row.dictMainOutlayType == 2"
                  >
                    卖方保证金
                  </div>
                  <div class="money-type" v-else>
                    {{ scope.row.outlayTypeStr }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                property="outlayAmountStr"
                label="应收金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="innerPaymentStr"
                label="当前可内扣金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="presentCost"
                label="本次内扣金额（元）"
                width="250"
              >
                <template slot-scope="scope">
                  <el-input
                    @change="changeCost"
                    type="number"
                    placeholder="请输入内容"
                    v-model="scope.row.presentCost"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </template>

          <template #depositMoney>
            <el-table
              ref="multipleTable"
              :data="marginList"
              border
              @selection-change="handleSelectionChange"
              style="width: 100%"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <!-- <el-table-column
                type="index"
                align="center"
                label="序号"
                width="50"
              >
              </el-table-column> -->
              <el-table-column
                align="center"
                property="moneyType"
                label="款项类型"
              >
                <template>
                  <div class="money-type">卖方保证金</div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                property="receivableAmountStr"
                label="应收金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="receivedAmountStr"
                label="已收金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="deductedAmountStr"
                label="已抵扣金额（元）"
                width="150"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="surplusAmountStr"
                label="保证金余额（元）"
                width="150"
              >
              </el-table-column>
            </el-table>
          </template>
        </avue-form>
        <CommonDetail v-else :configArray="addFormConfig" :initValue="formData">
        </CommonDetail>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import { paymentPlanAdjustAddConfig } from "../config";
import Accessory from "@/components/accessoriesother/accessory";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import CommonDetail from "@/components/commonDetail/commonDetail";
import InfoContainer from "@/components/infoContainer/infoContainer";
import {
  getLendingList,
  addLendingDetail,
  addLending,
  lendingDetail,
  deleteLending,
  cancelLending,
  queryBankList,
  queryMarginList,
} from "@/api/factoring/factoring";
import { floatAdd } from "@/util/util";
import { mapGetters } from "vuex";
export default {
  name: "paymentPlanAdjustForm",
  data() {
    return {
      selectProjectId: "",
      selectContractId: "",
      contractParam: {},
      tableData: [],
      lendingFormConfig: paymentPlanAdjustAddConfig(
        this.changeMoneyType,
        this.changeCost,
        this.changeInvestMoney
      ),
      lendingForm: {},
      formConfig: {
        infoTitle: "付款信息",
        infoContent: [
          {
            title: "基础信息",
            prop: "basicInfo",
          },
        ],
      },
      // 保证金数据
      marginList: [],
      multipleSelection: [],
    };
  },
  components: {
    Accessory,
    CommonSelect,
    CommentBlock,
    CommonDetail,
    InfoContainer,
  },

  props: {
    investId: {
      type: String,
      required: true,
    },
    investBatch: {
      type: String,
      required: true,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    // 传入的详细数据
    investData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    investId: {
      handler(newData, oldData) {
        this.queryAddLandingDetail();
      },
    },
    "lendingForm.moneyType": {
      handler(val) {
        this.$emit("getMoneyType", val);
      },
    },
  },
  mounted() {},
  methods: {
    async queryAddLandingDetail() {
      if (Object.keys(this.investData).length > 0) {
        this.lendingForm = JSON.parse(JSON.stringify(this.investData));

        this.lendingFormConfig.column[5].disabled = true;

        if (this.lendingForm.moneyType == 1) {
          this.changeMoneyType({ value: 1 });
        }

        this.lendingForm.otherCondition = this.lendingForm.remarks;
        this.lendingForm.actuallPayment = this.lendingForm.investShouldMoney;
        this.lendingForm.planPayDate = this.lendingForm.planPayDate;
        this.lendingForm.innerList = this.lendingForm.innerList;
        this.lendingForm.innerList.map((item) => {
          item.outlayAmountStr = `${this.getMoney(
            Number(item.outlayAmount)
          )}元`;
          item.innerPaymentStr = `${this.getMoney(
            Number(item.innerPayment)
          )}元`;
          item.presentCost = Number(item.innerMoney).toFixed(2);
        });
      } else {
        let res = await addLendingDetail({ investId: this.investId });
        this.lendingForm = res.data.data;

        // 处理内扣合计金额 本笔应实付金额
        this.lendingForm.presentCostSum = 0;
        this.lendingForm.actuallPayment = 0;

        this.lendingForm.innerList.map((item) => {
          item.outlayAmountStr = `${this.getMoney(
            Number(item.outlayAmount)
          )}元`;
          item.innerPaymentStr = `${this.getMoney(
            Number(item.innerPayment)
          )}元`;
        });
      }
      this.$emit(
        "getLastMoney",
        Number(this.lendingForm.investAllMoney) -
          Number(this.lendingForm.investAlreadyMoney)
      );
    },
    changeInvestMoney(data) {
      this.lendingForm.investMoney = data;
    },
    handleSelectionChange(val) {
      let self = this;
      let newArray = [];
      let marginTotal = 0;
      this.lendingForm.depositAmounts = [];

      // 处理保证金数据
      val.map((item, index) => {
        if (Number(item.surplusAmount) != 0) {
          // 计算保证金总额
          marginTotal =floatAdd(marginTotal,Number(item.surplusAmount)) ;
          newArray.push(item);
          // 设置上传数据
          self.lendingForm.depositAmounts.push({
            depositId: item.id,
            refundedAmount: item.surplusAmount,
          });
        } else {
          self.$refs.multipleTable.toggleRowSelection(item);
          self.$message.warning(`第${item.index}条保证金数据余额为0无法选择`);
        }
      });
      this.multipleSelection = newArray;

      this.lendingForm.investMoney = marginTotal;
    },

    async changeMoneyType(data) {
      let self = this;
      let innerIncludesArray = [
        "innerMoney",
        "rentDate",
        "presentCostSum",
        "actuallPayment",
      ];
      let depositIncludesArray = ["depositMoney"];
      this.lendingFormConfig.column.map((item) => {
        if (innerIncludesArray.includes(item.prop)) {
          item.display = data.value == 0 ? true : false;
        }
        if (depositIncludesArray.includes(item.prop)) {
          item.display = data.value == 0 ? false : true;
        }
        if (item.prop == "investMoney") {
          item.disabled = data.value == 0 ? false : true;
        }
      });

      if (data.value == 1) {
        let newArray = [];
        this.lendingForm.depositAmounts = [];
        // 查询保证金数据
        let res = await queryMarginList({ investId: this.investId });
        if (res.data.code == 200) {
          this.marginList = res.data.data;
          this.marginList.map((item, index) => {
            item.index = index + 1;
            item.receivableAmountStr = `${self.getMoney(
              Number(item.receivableAmount)
            )}元`;
            item.receivedAmountStr = `${self.getMoney(
              Number(item.receivedAmount)
            )}元`;
            item.deductedAmountStr = `${self.getMoney(
              Number(item.deductedAmount)
            )}元`;
            item.surplusAmountStr = `${self.getMoney(
              Number(item.surplusAmount)
            )}元`;
            if (item.refundedAmount != "" && item.refundedAmount != 0) {
              newArray.push(item);
            }
          });

          this.multipleSelection = newArray;
          setTimeout(() => {
            if (newArray.length > 0) {
              newArray.map((item) => {
                self.$refs.multipleTable.toggleRowSelection(item);
              });
            }
          }, 300);
        }
      }
    },
    changeCost() {
      this.lendingForm.presentCostSum = 0;
      this.lendingForm.innerList.map((item) => {
        if (item.presentCost) {
          this.lendingForm.presentCostSum =floatAdd(this.lendingForm.presentCostSum,Number(item.presentCost)) ;
        }
      });
      // 计算笨比应实付金额
      if (this.lendingForm.investMoney && this.lendingForm.investMoney != "") {
        this.lendingForm.actuallPayment =
          this.lendingForm.investMoney - this.lendingForm.presentCostSum;
      } else {
        this.$message({
          type: "warning",
          message: "请先输入本笔付款金额",
        });
      }
      this.$forceUpdate();
    },
    validFormData() {
      let self = this;
      let msg = "";
      return new Promise((resolve, reject) => {
        this.$refs.lendingInfo.validate((valid, done) => {
          done();
          if (valid) {
            // 校验内扣明细
            let formFinish = true;
            if (self.lendingForm.moneyType == 0) {
              self.lendingForm.innerList.map((item) => {
                if (!item.presentCost || item.presentCost == "") {
                  formFinish = false;
                  msg = "请补全内扣明细本次内扣金额";
                }
              });
            } else {
              // 判断是否有勾选
              if (
                self.lendingForm.investMoney == 0 ||
                self.lendingForm.investMoney == ""
              ) {
                formFinish = false;
                msg = "本笔付款金额为0无法发起付款";
              }
            }

            if (formFinish) {
              resolve(true);
            } else {
              self.$message({
                type: "warning",
                message: msg,
              });
            }
          } else {
            self.$message({
              type: "warning",
              message: "请补全表单后提交",
            });
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>